import type { ConditionOutput, FlowNodeResultADT } from '@lighthouse/shared'
import { type ConditionFlowNode, ConditionRunType, filterRecordChecker, getElseHandleId, resolveFilter } from '@lighthouse/shared'

import type { ExecuteActionParams } from '../type'

export const handleCondition = (node: ConditionFlowNode, params: ExecuteActionParams): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config, name },
        id
    } = node

    const { filterGroup, runType } = config || {}
    const { parseVariable2Field, upstreamNodesResult, scope } = params
    const elseId = getElseHandleId()
    // 是否通过校验
    // const isPass = false

    const conditionResult: ConditionOutput[] = filterGroup.map((filter, i) => ({
        id: filter.id,
        name: `情况${i}`,
        isPass: false
    }))

    for (const [index, filterItem] of filterGroup.entries()) {
        let isPass = false
        const { filter, id } = filterItem
        if (!filter?.expression?.conditions?.length) {
            conditionResult[index].isPass = isPass
            continue
        }
        const resolvedFilter = resolveFilter({ filter, extraParams: params, useInFilterRecordChecker: true })
        // const
        if (!resolvedFilter?.expression?.conditions?.length) {
            conditionResult[index].isPass = isPass
            continue
        }
        isPass = filterRecordChecker({
            filter: resolvedFilter,
            getVariableToFieldValue: value => parseVariable2Field(value, { upstreamNodesResult, scope }),
            initStatus: false
        })

        conditionResult[index].isPass = isPass
        if (runType === ConditionRunType.UNIQUE && isPass) {
            break
        }
    }

    const elseResult = conditionResult.every(result => !result.isPass)
    conditionResult.push({
        id: elseId,
        name: '否则',
        isPass: elseResult
    })

    return Promise.resolve({
        type: 'condition',
        data: conditionResult,
        success: true
    })
}
